import { render, staticRenderFns } from "./ReportEntityDetails.vue?vue&type=template&id=63af588b&"
import script from "./ReportEntityDetails.vue?vue&type=script&lang=js&"
export * from "./ReportEntityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63af588b')) {
      api.createRecord('63af588b', component.options)
    } else {
      api.reload('63af588b', component.options)
    }
    module.hot.accept("./ReportEntityDetails.vue?vue&type=template&id=63af588b&", function () {
      api.rerender('63af588b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ReportEntityDetails.vue"
export default component.exports